module.exports = __webpack_public_path__ + "static/img/logo_black.c8d4789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_black.png
// module id = q3zs
// module chunks = 44